import React, { useState } from "react";
import { postCuentaGasto as addCuentaGasto } from "../helpers/rutaCuentaGastos";
import "../css/addclienteform.css";
import { Modal } from "react-bootstrap";
import "animate.css";

const AddCuentaGastoForm = ({ setShow }) => {
  const [showSuccess, setShowSuccess] = useState(false);

  const [formValues, setFormValues] = useState({
    codcga: "",
    cuentagasto: "",
    activo: true,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const resetForm = () =>
    setFormValues({
      codcga: "",
      cuentagasto: "",
      activo: true,
    });

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      cuentagasto: String(formValues.cuentagasto || "").trim(),
      activo: !!formValues.activo,
    };

    try {
      const resp = await addCuentaGasto(payload);
      console.log("✅ CuentaGasto creada:", resp);

      if (resp?.ok === false) {
        console.error("❌ Error:", resp?.error || resp);
        return;
      }

      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
        resetForm();
        // setShow(false);
      }, 2000);
    } catch (error) {
      console.error("❌ Error al crear CuentaGasto:", error?.response?.data || error);
    }
  };

  return (
    <>
      <div className="container">
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group mt-3 col-sm-6">
              <label>Cuenta</label>
              <input
                type="text"
                className="form-control"
                name="cuentagasto"
                maxLength="50"
                required
                value={formValues.cuentagasto}
                onChange={handleChange}
              />
              <small className="text-muted">
                Ej: SERVICIOS, COMBUSTIBLE, MANTENIMIENTO
              </small>
            </div>

            <div className="form-group mt-5 col-sm-3 d-flex align-items-center">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="activo"
                  name="activo"
                  checked={!!formValues.activo}
                  onChange={handleChange}
                />
                <label className="form-check-label" htmlFor="activo">
                  Activo
                </label>
              </div>
            </div>
          </div>

          <div>
            <button type="submit" className="btn btn-dark mt-5 mb-3" id="button">
              Guardar
            </button>
          </div>
        </form>
      </div>

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div style={{ fontSize: "3rem" }}>🧾</div>
          <h5 className="mt-2">¡Cuenta creada correctamente!</h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddCuentaGastoForm;